import { Box3, Object3D, Vector3 } from 'three';
import { ProjectRenderer } from '../ProjectRenderer';
import { CustomObjectName } from '../types';
import { AssetsLib } from '../utils/AssetsLib';

import { Door } from '@/api/DoorApi';
import { RenderUtils } from '../utils/RenderUtils';

export class DoorManager {
	private _selectedDoor: Door | null = null;
	private assetsLib = AssetsLib.getInstance();
	private object: Object3D | null = null;

	constructor(private renderer: ProjectRenderer) {}

	get selectedDoor() {
		return this._selectedDoor;
	}

	set selectedDoor(door: Door | null) {
		this.dispose();
		this._selectedDoor = door;

		this.setDoor();
	}

	private async setDoor() {
		if (!this._selectedDoor) return;

		if (!this._selectedDoor.model3d.model)
			throw new Error('MISSING_DOOR_MODEL');

		this.object = await this.assetsLib.getModel(
			this._selectedDoor.model3d.model.path
		);

		const handleSlot = this.object.getObjectByName(
			CustomObjectName.HANDLE_SLOT
		);

		if (!handleSlot) throw new Error('MISSING_HANDLE_SLOT');

		const worldPosition = new Vector3();
		handleSlot.getWorldPosition(worldPosition);

		const projectBoudingBox = new Box3().setFromObject(this.renderer.project);

		const upperPostZMin = projectBoudingBox.min.z;

		const handleTarget = this.renderer.project.position.clone();
		handleTarget.setZ(upperPostZMin);

		const delta = handleTarget.clone().sub(worldPosition);

		this.object.position.add(delta);

		this.renderer.scene.add(this.object);
	}

	private dispose() {
		if (!this.object) return;

		this.renderer.scene.remove(this.object);
		RenderUtils.disposeObject(this.object);
	}
}
